<!-- 表单授权功能未授权人员列表数据 -->
<template>
    <div class="unauth-user-content">
        <div class="searchUn" @keyup.enter="handleSearchUnAuthUser">
              <el-input maxlength="100" v-model.trim="searchParams.unAssignedUserName" placeholder="员工姓名" style="width: 360px;padding-bottom: 6px;">
                  <el-button slot="append" icon="el-icon-search" @click="handleSearchUnAuthUser"></el-button>
              </el-input>
          </div>
          <div>
              <el-table :data="unAssignedUserList" style="width: 100%" :border="true" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40"> </el-table-column>
                  <el-table-column width="150" prop="trueName" label="姓名"></el-table-column>
                  <el-table-column prop="userName" label="账号"></el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-row type="flex" justify="end" style="margin-top: 10px;">
                  <el-pagination
                      background
                      layout="total, prev, pager, next"
                      :total="noAuthPage.totalPageNum"
                      :current-page="noAuthPage.currentPage"
                      :page-size="noAuthPage.pageSize"
                      @current-change="handleSearchNoAuthListAssigned"
                      >
                  </el-pagination>
              </el-row>
          </div>
    </div>

</template>

<script>
    import {getAppUnAssignList, publishApplication, saveApplicationModelUserAuth} from '@/data-model';
    export default{
        data () {
            return {
                searchParams: {
                    mode: 2,
                    appId: '',
                    modelId: '',
                    formId: '',
                    modelName: '暂无选择',
                    assignedUserName: '',
                    unAssignedUserName: ''
                },
                unAssignedUserList: [],
                multipleSelectionUsers: [],
                noAuthPage: {
                    currentPage: 1,
                    pageSize: 10,
                    totalPageNum: 1
                },
                modelUserAuth: {
                    id: '',
                    modelId: '',
                    formId: '',
                    userId: '',
                    modelAuthList: '',
                    users: ''
                },
                appPublishData: {
                    appName: '',
                    appId: '',
                    modelIds: '',
                    users: [],
                    userNames: [],
                    state: ''
                }
            };
        },
        props: {
            appId: {
                type: String
            },
            modelId: {
                type: String
            },
            formId: {
                type: String
            },
            modelName: {
                type: String
            }
        },
        created () {
            this.searchParams.appId = this.appId;
            this.searchParams.modelId = this.modelId;
            this.searchParams.modelName = this.modelName;
            this.searchParams.formId = this.formId;
            this.initUnUsersAuthList();
        },
        methods: {
            handleSearchUnAuthUser () {
                this.searchParams.mode = 2;
                this.initUnUsersAuthList();
            },
            handleSelectionChange (val) {
                this.multipleSelectionUsers = val;
            },
            handleSearchNoAuthListAssigned (currentPage) {
                this.noAuthPage.currentPage = currentPage;
                this.initUnUsersAuthList();
            },
            async initUnUsersAuthList () {
                let formData = await getAppUnAssignList(Object.assign({}, {
                    currentPage: this.noAuthPage.currentPage,
                    pageSize: this.noAuthPage.pageSize
                }, this.searchParams));
                this.noAuthPage.currentPage = formData.currentPage;
                this.noAuthPage.pageSize = formData.pageSize;
                this.noAuthPage.totalPageNum = formData.totalPageNum;
                this.unAssignedUserList = formData.data;
            },
            async grantFormAuthUser () {
                this.appPublishData.users = [];
                this.appPublishData.userNames = [];
                this.appPublishData.authIds = [];
                if (this.multipleSelectionUsers.length !== 0) {
                    this.multipleSelectionUsers.forEach((v, i) => {
                        this.appPublishData.users.push(v.userId);
                        this.appPublishData.userNames.push(v.trueName);
                        this.appPublishData.authIds.push(v.authId);
                    });
                }
                if (this.appPublishData.users === undefined || this.appPublishData.users.length === 0) {
                    this.messageTip('请选择人员', 'warning');
                    return false;
                }
                this.appPublishData.modelIds = this.searchParams.modelId;
                this.appPublishData.appId = this.searchParams.appId;
                this.appPublishData.users = this.appPublishData.users.join(',');
                let usersNames = this.appPublishData.userNames.join(',');
                this.$confirm(`您确定要给人员：[${usersNames}]  授权应用模型：[ ${this.searchParams.modelName} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
					customClass:'showAuthUserList',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await publishApplication(this.appPublishData);
                    // 默认给当前选中的人员赋值查看表单的权限
                    this.modelUserAuth.modelId = this.searchParams.modelId;
                    this.modelUserAuth.formId = this.searchParams.formId;
                    this.modelUserAuth.users = this.appPublishData.users;
                    this.modelUserAuth.modelAuthList = '0,1,2,3,4,5,6,7';
                    await saveApplicationModelUserAuth(this.modelUserAuth);
                    loading.close();
                    // 刷新父节点列表
                    this.multipleSelectionUsers = [];
                    this.$emit('reloadData');
                }).catch(() => {});
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            }
        }
    };
</script>

<style lang="less">
    .el-message-box__message p{
        margin: 0;
        line-height: 24px;
        max-height: 300px;
        overflow: auto;
    }
.showAuthUserList{
    p{
        max-height: 300px;
        overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/GrantAuthUser/GrantAuthUser.vue